import {useState} from 'react';
import {useMediaQuery} from 'react-responsive';
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import leftArr from '../../../../../../../images/product-swiper-arrow-black-right.svg';
import Graph1Img from '../../../../../../../images/graphs/dividend-portfolio-usa.svg';
import Graph2Img from '../../../../../../../images/graphs/optimal-portfolio-usa.svg';
import Graph3Img from '../../../../../../../images/graphs/long-term-portfolio-china.svg';
import LastBlock from './last-block/last-block';
import styles from './gallery-tables.module.css';

function GalleryTablesProduct() {
    const isMobile = useMediaQuery({query: '(max-width: 760px)'});
    const [swiper, setSwiper] = useState(null);

    return (
        <div className={styles.section}>
            <div className={styles.containerWrapper}>
                <div className={styles.navigationBox}>
                    <div className={styles.chartsTitle}>Наша доходность</div>
                    {!isMobile && (
                        <div className={styles.swipeBtns}>
                            <button
                                className={styles.swipeBtn}
                                onClick={() => {
                                    swiper && swiper.slidePrev();
                                }}>
                                <img src={leftArr} className={styles.leftArr} alt={'left array'}/>
                            </button>
                            <button
                                className={styles.swipeBtn}
                                onClick={() => {
                                    swiper && swiper.slideNext();
                                }}>
                                <img src={leftArr} className={styles.rightArr} alt={'right array'}/>
                            </button>
                        </div>
                    )}
                </div>

                <div className={styles.slider}>
                    <Swiper
                        className={styles.swiper}
                        onInit={(swiper) => setSwiper(swiper)}
                        slidesPerView={isMobile ? 1.3 : 2.2}
                        spaceBetween={isMobile ? 8 : 20}
                    >
                        <SwiperSlide className={styles.swiperSlide}>
                            <img src={Graph1Img} className={styles.img} alt={'Дивидендный портфель США'}/>
                        </SwiperSlide>
                        <SwiperSlide className={styles.swiperSlide}>
                            <img src={Graph2Img} className={styles.img} alt={'Оптимальный портфель США'}/>
                        </SwiperSlide>
                        <SwiperSlide className={styles.swiperSlide}>
                            <img src={Graph3Img} className={styles.img} alt={'Долгосрочный портфель Китай'}/>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={styles.img}>
                                <LastBlock subName={'Unity World'} subHref={'UnityWorldPrice'}/>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>
            </div>
        </div>
    );
}

export default GalleryTablesProduct;
